var map = {
	"./0.88.png": "c3bc",
	"./1.08.png": "c1d2",
	"./1.88.png": "25c1",
	"./18.88.png": "6a8e",
	"./188.png": "a1c2",
	"./8.88.png": "3eb7",
	"./bg2.png": "86ab",
	"./btn1.png": "0588",
	"./btn2.png": "c68a",
	"./btn3.png": "990b",
	"./close.png": "673e",
	"./empty.png": "1a1f",
	"./gift.png": "5535"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df68";